const FormatCurrency = (amount) => {
  const settings = { style: 'currency', currency: 'MXN' }
  const number = new Intl.NumberFormat('en-MX', settings)

  return number.format(amount)
}

const Sum = (total, models, model = null, modality, extras) => {
  let modelPrice = 0
  let extrasPrice = 0

  if(model) {
    if (modality.value === 'Sin amueblar' && model.checked) {
      modelPrice = parseFloat(model.getAttribute('price-not-furnished'))
    }
    if (modality.value === 'Amueblado' && model.checked) {
      modelPrice = parseFloat(model.getAttribute('price-furnished'))
    }
  } else {
    models.forEach((model) => {
      if (modality.value === 'Sin amueblar' && model.checked) {
        modelPrice = parseFloat(model.getAttribute('price-not-furnished'))
      }
      if (modality.value === 'Amueblado' && model.checked) {
        modelPrice = parseFloat(model.getAttribute('price-furnished'))
      }
    })
  }

  extras.forEach((extra) => {
    if (extra.checked)
      extrasPrice = parseFloat(extrasPrice) + parseFloat(extra.getAttribute('price'))
  })

  total.value = FormatCurrency(modelPrice + extrasPrice)
}

export const Modality = () => {
  const form = document.querySelector('#quote-form')
  const tower = form.querySelector('[name="tower"]')
  const modality = form.querySelector('[name="modality"]')
  let towerEquipment = document.querySelector(`[tower-equipment="${tower.value}"]`)

  const ChangeOptions = () => {
    if (modality.value === 'Sin amueblar') {
      towerEquipment.querySelector('[not-furnished]').style.display = 'block'
      towerEquipment.querySelector('[furnished]').style.display = 'none'
    }
    if (modality.value === 'Amueblado') {
      towerEquipment.querySelector('[furnished]').style.display = 'block'
      towerEquipment.querySelector('[not-furnished]').style.display = 'none'
    }
  }

  modality.addEventListener('change', (e) => {
    ChangeOptions()
  })

  tower.addEventListener('change', (e) => {
    towerEquipment = document.querySelector(`[tower-equipment="${tower.value}"]`)
    ChangeOptions()
  })
}

const QuoteForm = () => {
  const form = document.querySelector('#quote-form')

  if (!form) return

  const total = form.querySelector('[name="total"]')
  const models = form.querySelectorAll('[name="model"]')
  const modality = form.querySelector('[name="modality"]')
  const extras = form.querySelectorAll('[name="extras[]"]')
  let currentModel

  models.forEach((model) => {
    model.addEventListener('change', (e) => {
      currentModel = model
      Sum(total, models, model, modality, extras)
    })
  })
  modality.addEventListener('change', (e) => {
    Sum(total, models, currentModel, modality, extras)
  })
  extras.forEach((extra) => {
    extra.addEventListener('change', (e) => {
      Sum(total, models, currentModel, modality, extras)
    })
  })

  setTimeout(() => {
    modality.dispatchEvent(new Event('change'))
  }, 10)
}
export default QuoteForm
